/**
 * useProfile Hook
 * Fetches user profile by username using TanStack Query
 */

import { useQuery } from '@tanstack/react-query'
import { profileRepo } from '@/lib/repositories'
import type { Profile } from '@/lib/repositories/interfaces/IProfileRepository'

export const PROFILE_QUERY_KEY = (username: string) =>
  ['profile', username] as const

export function useProfile(username: string | undefined) {
  return useQuery<Profile | null, Error>({
    queryKey: PROFILE_QUERY_KEY(username || ''),
    queryFn: () =>
      username ? profileRepo.getProfile(username) : Promise.resolve(null),
    enabled: !!username, // Only fetch if username is provided
    staleTime: 5 * 60 * 1000, // 5 minutes (profiles change infrequently)
  })
}
